import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import { DropdownArrowIcon } from "../../icons/index.js";
import ToolbarButton from "../ToolbarButton/ToolbarButton.js";
const DropdownButton = ({
  Icon,
  dataHook,
  tooltip,
  onClick,
  label,
  active,
  setRef,
  disabled
}) => {
  const { isMobile } = useContext(RicosContext) || {};
  const DropdownIcon = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, null), label, /* @__PURE__ */ React.createElement(DropdownArrowIcon, null));
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      ref: setRef,
      isMobile,
      tooltip,
      onClick,
      active,
      disabled,
      Icon: DropdownIcon,
      dataHook
    }
  );
};
var DropdownButton_default = DropdownButton;
export {
  DropdownButton_default as default
};
//# sourceMappingURL=DropdownButton.js.map
